const largeDurationTypeInHours = 1.5;

export default largeDurationTypeInHours;
